import { render, staticRenderFns } from "./PopupDestination.vue?vue&type=template&id=206dcec1&scoped=true&"
import script from "./PopupDestination.vue?vue&type=script&lang=js&"
export * from "./PopupDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206dcec1",
  null
  
)

export default component.exports